import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de equivalencia de artículos
 */
class EquivalenciaArticuloRequest {
    /**
     * Llamada el endpoint de django para obtener los artículos
     * en la BD
     * @param: nada
     * @return: Una lista de artículos.
     */
    static ListarEquivalencias(data) {
        return middleware.hasAuth(() => request.get(`api/equivalencia-articulo/`, {
            params: {
                sitios: data?.sitios.toString(),
                articulo_id: data?.articulo_id
            }
        }))
    }

    /**
     * Llamada el endpoint de django para crear / editar una categoría
     * @param: value. id de la categoría
     * @param: data. objeto con información de la categoría
     * @return: Mensaje de éxito o error.
     */
    static EditarEquivalencias(data) {
        return middleware.hasAuth(() => request.post(`api/equivalencia-articulo/`, data));

    }

    /**
     * Llamada el endpoint de django para eliminar categoría
     * @param: value. id de la categoría
     * @return: Mensaje de éxito o error.
     */
    static EliminarEquivalencia(value) {
        return middleware.hasAuth(() => request.put(`api/equivalencia-articulo/delete/${value}/`));
    }
}

export default EquivalenciaArticuloRequest;